import React from "react";
import {
  Box,
  Modal,
  ModalDialog,
  ModalClose,
  Typography,
  List,
  ListItem,
  ListItemContent,
  Switch,
  Divider,
  Stack,
} from "@mui/joy";
import { useAssignments } from "../../../contexts/controllers/useAssignments";
import { ProviderServicePoint } from "../../../api/assignments/Assignments.domain";

const ServicePointsMenu: React.FC<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => {
  const { getServiceProviders, updateProviderInformations } = useAssignments();
  const [providers, setProviders] = React.useState<ProviderServicePoint[]>([]);
  const [loading, setLoading] = React.useState(true);

  const fetchProviders = async () => {
    try {
      const response = await getServiceProviders();
      if (response?.response?.servicePoints) {
        setProviders(response.response.servicePoints);
      }
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (open) {
      fetchProviders();
    }
  }, [open]);

  const handleToggleProvider = async (provider: ProviderServicePoint) => {
    try {
      await updateProviderInformations(provider.providerId, {
        request: {
          servicePoints: [
            {
              ...provider,
              isActive: !provider.isActive,
            },
          ],
        },
      });
      await fetchProviders();
    } catch {
      // Intentionally ignore errors
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog
        size="lg"
        sx={{
          minWidth: "600px",
          maxWidth: "800px",
          width: "80vw",
          maxHeight: "80vh",
          overflow: "auto",
        }}
      >
        <ModalClose />
        <Typography level="h4" sx={{ mb: 2 }}>
          Paramètres des points de service
        </Typography>
        {loading ? (
          <Typography>Chargement...</Typography>
        ) : providers.length === 0 ? (
          <Typography>Aucun point de service trouvé</Typography>
        ) : (
          <List
            sx={{
              "--ListItem-paddingY": "1rem",
              "--ListItem-paddingX": "1rem",
            }}
          >
            {providers.map((provider) => (
              <React.Fragment key={provider.providerId}>
                <ListItem>
                  <ListItemContent>
                    <Typography level="title-sm">{provider.name}</Typography>
                    <Typography level="body-sm">Type: {provider.type}</Typography>
                    <Typography level="body-sm">Code: {provider.logisticsMode?.code}</Typography>
                    <Typography level="body-sm">Provider ID: {provider.providerId}</Typography>
                  </ListItemContent>
                  <Stack spacing={1} alignItems="center">
                    <Typography level="body-sm">
                      {provider.isActive ? "Point de service actif" : "Point de service inactif"}
                    </Typography>
                    <Switch
                      checked={provider.isActive}
                      onChange={() => handleToggleProvider(provider)}
                    />
                  </Stack>
                </ListItem>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        )}
      </ModalDialog>
    </Modal>
  );
};

export default ServicePointsMenu;
